import { SVGProps, Ref, forwardRef } from 'react';

export const ArrowDiagonalRightUpOutlinedSize16Glyph = forwardRef(
    (props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) => (
        <svg
            width={16}
            height={16}
            viewBox="0 0 16 16"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            ref={ref}
            {...props}
        >
            <g>
                <path d="M4.5 2.5h9v9h-1.4V4.891L3.5 13.5l-1-1 8.61-8.6H4.5z" fill="currentColor" />
            </g>
        </svg>
    )
);
ArrowDiagonalRightUpOutlinedSize16Glyph.displayName = 'ArrowDiagonalRightUpOutlinedSize16Glyph';
